import { lazyload } from 'labguard-cdk'

export default lazyload(() => import(/* webpackChunkName: "system-alarms" */ './SystemAlarms'))
